/**
 * @todo rewrite in vanilla js
 */
export default function() {
    const $toggle = $(".accordion__header");

    $toggle.on('click', function() {
        toggleItem($(this).parent(".accordion__item"));
    });

    // make sure first accordion is open by default
    toggleItem($(".accordion__item").eq(0));
}

function toggleItem($item) {
    const $body = $item.find(".accordion__body");
    // toggle class
    $item.toggleClass('accordion__item--active');
    // toggle height between 0 for hidden & natural element height for active
    if ( $item.hasClass('accordion__item--active') ) {
        const height = $body.get(0).scrollHeight;
        $body.css('height', height);
    } else {
        $body.css('height', 0);
    }
}